import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledGroupSearchFormMobile = styled.div<{ isSearchResultPage: boolean }>`
  padding: ${props => (!props.isSearchResultPage ? `${toRem(24)} ${toRem(29)} ${toRem(16)}` : `0`)};
  .w-100 {
    width: 100%;
  }
`;
